import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Pages } from 'core/pages';

const TeamRankingDashboard = lazy(() => import('./Dashboard'));
const CreateTeamRanking = lazy(() => import('./Create'));
const TeamRankingList = lazy(() => (import('./TeamList')));
const TeamRankingUpdate = lazy(() => import('./UpdateTeamRanking'));
const TeamRankingVersion = lazy(() => import('./TeamRankingVersion'));
const TeamRankingRead = lazy(() => import('./ResourcePage'));

export function TeamRankingRoutes() {
  return (
    <Routes>
      <Route path={Pages.sports.cricket.TeamRanking.meta.path}>
        <Route
          index
          element={<TeamRankingDashboard />}
        />
        <Route
          path={Pages.sports.cricket.TeamRanking.create.meta.path}
          element={<CreateTeamRanking />}
        />
        <Route
          path={Pages.sports.cricket.TeamRanking.list.meta.path}
          element={<TeamRankingList />}
        />
        <Route
          path={Pages.sports.cricket.TeamRanking.update.meta.path}
          element={<TeamRankingUpdate />}
        />
        <Route
          path={Pages.sports.cricket.TeamRanking.version.meta.path}
          element={<TeamRankingVersion />}
        />
        <Route
          path={Pages.sports.cricket.TeamRanking.read.meta.path}
          element={<TeamRankingRead />}
        />
      </Route>
    </Routes>
  );
}
